import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";

export default function Shop() {
    const items = [
        {
            name: "Available for Preorder. Ships Approx Jan/Feb 2026",
            title: "Standard Edition: Beginner Friendly",
            cost: "114.99",
            image: "/images/shop/standard_kit.png",
            link: "https://shop.takamorirobot.com/products/h-i-r-o-tr-01-a-standard-edition-pre-order-here",
        },
        {
            name: "Early Access. Limited Edition. Exclusive Merch Included",
            title: "Trailblazer Edition:  Intermediate - Advanced",
            cost: "249.99",
            image: "/images/shop/trailblazer_kit.png",
            link: "https://shop.takamorirobot.com/products/h-i-r-o-robotics-kit-trailblazers-edition",
        }
    ];
    
    return (
        <div className="flex flex-col w-full h-full items-center justify-center">
            <Header />
            <div className="flex flex-col w-[90%] md:w-[80%] lg:w-[60%] min-h-screen items-top justify-center md:justify-start gap-y-[2rem] mt-[5rem] overflow-hidden">
                <h1 className="font-bold text-2xl text-center sm:text-start">Welcome to our Takamori Shop!</h1>
                
                {/* Shop grid */}
                <div className="flex flex-wrap justify-center sm:justify-start gap-y-[5rem] gap-x-[5rem]">           
                {items.map((items, index) => (
                    <a
                        key={index}
                        href={items.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block w-[20rem] group"
                    >
                        <p className="font-semibold text-sm my-[0.2rem]">{items.title}</p>
                        {/* Card */}
                        <div key={index} className="flex flex-col items-start">
                            <img
                                src={items.image}
                                alt={items.name}
                                className="w-[120%] h-auto rounded-xl object-cover"
                            />
                            <div className="flex flex-col">
                                <p className="text-sm font-semibold text-gray-700 group-hover:underline">{items.name}</p>
                                <p className="text-lg">${items.cost} USD</p>
                            </div>
                        </div>
                    </a>
                ))}
                </div>

            </div>
            <Footer />
        </div>
    )
}